export default {
  name: 'oz-amount',

  data () {
    return {
      selectedOptions: [],
    }
  },

  props: {
    model: {
      type: String,
      required: true,
      validator: (value) => ['bedrooms', 'bathrooms', 'parkingSpaces'].includes(value),
    },
    title: { type: String, required: true },
    singularTitle: { type: String, required: true },
    filters: { type: [String, Number], required: true },
    options: {
      type: Array,
      default () {
        return Array.from({ length: 4 }, (_, index) => {
          const value = (index + 1).toString()
          const label = value === '4' ? '4+' : value
          return { label, value }
        })
      },
    },
  },

  created () {
    if (this.filters) this.selectedOptions = this.filters.split(',')
  },

  watch: {
    filters () {
      this.selectedOptions = this.filters ? this.filters.split(',') : []
    },
  },

  methods: {
    isSelected (value) {
      return this.selectedOptions.some((option) => option === value)
    },

    selectOption (value) {
      const options = new Set()
      this.selectedOptions.forEach((el) => options.add(el))
      const hasValue = options.has(value)

      if (hasValue) {
        options.delete(value)
      } else {
        options.add(value)
      }

      this.selectedOptions = [...options]
      this.updateFilter([...options])
    },

    updateFilter (options = []) {
      const selectedOptions = options.toString()
      this.$emit('filters:update', { [`${this.model}`]: selectedOptions })
    },
  },
}
